import React from "react";
import "./TrustStrip.css";

const TRUST_STRIP = [
  "SOC 2 readiness",
  "Multi-tenant isolation",
  "US & UAE coverage",
  "GDPR alignment",
  "Regulatory mapping",
  "Permission-aware AI",
];

export default function TrustStrip({ className = "" }) {
  return (
    <section className={`trust-strip ${className}`.trim()} aria-label="Trust highlights">
      <div className="trust-strip__track">
        {[0, 1].map((copy) => (
          <ul key={copy} aria-hidden={copy === 1 || undefined}>
            {[0, 1, 2].flatMap((rep) =>
              TRUST_STRIP.map((item) => (
                <li key={`${copy}-${rep}-${item}`}>
                  <i aria-hidden="true">✓</i>
                  {item}
                </li>
              ))
            )}
          </ul>
        ))}
      </div>
    </section>
  );
}
